import { z } from 'zod';
import { GUEST_EMAIL_MAX_LENGTH, GUEST_FULL_NAME_MAX_LENGTH } from './constants/guest-registration';
import { EVENTS_STRINGS } from './constants/events-strings';

const G = EVENTS_STRINGS.GUEST;

/** Form schema for `GuestRegistrationModal` (FR-282): Full name and Email only, both trimmed. */
export const guestRegistrationSchema = z.object({
  fullName: z.string().trim().min(1, G.FULL_NAME_REQUIRED).max(GUEST_FULL_NAME_MAX_LENGTH, G.FULL_NAME_TOO_LONG),
  email: z
    .string()
    .trim()
    .min(1, G.EMAIL_REQUIRED)
    .max(GUEST_EMAIL_MAX_LENGTH, G.EMAIL_TOO_LONG)
    .email(G.EMAIL_INVALID),
});

export type GuestRegistrationFormValues = z.infer<typeof guestRegistrationSchema>;
